import React from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import classNames from 'classnames/bind';

import { ILocation } from './types';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface CurrentMarkerProps {
  location: ILocation;
}

const CurrentMarker: React.FC<CurrentMarkerProps> = ({ location }) => {
  return (
    <AdvancedMarker
      position={{ lat: location.latitude, lng: location.longitude }}
    >
      <div className={cx('Place')} />
    </AdvancedMarker>
  );
};

export default CurrentMarker;
